<h2 mat-dialog-title *ngIf="!editMode">{{ 'T4.Campaigns.PartnerCampaign.titleCreateCampaign' | translate:'Create a offer'}}</h2>
<h2 mat-dialog-title *ngIf="editMode && canEdit">{{ 'T4.Campaigns.PartnerCampaign.titleEditCampaign' | translate:'Edit a offer'}}</h2>
<h2 mat-dialog-title *ngIf="editMode && !canEdit">{{ 'T4.Campaigns.PartnerCampaign.titleOfferDetails' | translate:'Offer Details'}}</h2>

<mat-dialog-content style="overflow:hidden">
  <mat-spinner *ngIf="loading" style=" position: absolute; top: 50%; left: 50%; width: 100px; height: 100px; z-index: 50; transform: translate(-50%, -50%);"></mat-spinner>
  <div *ngIf="loading" style="position: absolute; z-index: 45; height: 90%; width: 100%; left: 0; right: 0; background-color: #ffffffb8; opacity: 0.8; filter: blur(1px);">
  </div>

  <mat-divider style="margin-bottom:10px;"></mat-divider>
  <form [formGroup]="campaignForm">
    <div class="row" style="display:flex; justify-content:space-evenly;">

      <div #previewScrollableContainer style="background: rgb(244, 244, 244); padding: 30px; border: 1px solid #ccc; background: #fff; overflow-y: scroll;" class="col-6">

        <ng-container *ngIf="listView && !loading">
          <div style="position: relative; max-width: 400px; margin: 10px auto 10px auto; box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, .2), 0px 1px 1px 0px rgba(0, 0, 0, .14), 0px 1px 3px 0px rgba(0, 0, 0, .12); background-color: white; border-radius:15px;">
            @if(offerType != 3){
            <div style="text-align: center; width: 100%; margin: auto; align-content: center; border-radius: 15px 15px 0 0;">
              <img [src]="image.Data ? 'data:image/png;base64,' + image.Data : '/Images/DiscountPlaceholder.jpg'" alt="Image Missing" style="max-width: 100%; border-radius: 15px 15px 0 0;">
            </div>
            }
            <div style="text-align:center; padding:10px;">

              <h1 style="color: #ff5f00" class="fixed-height-title">
                <span *ngIf="(!campaignForm.value.Title || campaignForm.value.Title.trim() === '') && !editMode">{{ 'T4.CampaignCard.Placeholder.headline' | translate:'Headline'}}</span>
                <span *ngIf="campaignForm.value.Title && campaignForm.value.Title.trim() !== ''">{{campaignForm.value.Title}}</span>
              </h1>

              <p class="fixed-height-desc">
                <span style="color:gray" *ngIf="(!campaignForm.value.Comment || campaignForm.value.Comment.trim() === '') && !editMode">{{ 'T4.CampaignCard.Placeholder.description' | translate: 'Description'}}</span>
                <span *ngIf="campaignForm.value.Comment && campaignForm.value.Comment.trim() !== ''">{{campaignForm.value.Comment}}</span>
              </p>
              @if(offerType == 1){
              <button style="border-radius:25px;" mat-raised-button color="primary">{{ 'T4.CampaignCard.btnUseNow' | translate:'Use now'}}</button>
              }
              @else if(offerType == 2){
              <button style="border-radius:25px;" type="button" mat-raised-button color="primary" (click)="openInNewTab(campaignForm.value.ExternalCode)"> {{ 'T4.CampaignCard.btnReadMore' | translate:'Read more'}}</button>
              }

              @if(offerType == 1 || offerType == 2){
                <p *ngIf="campaignForm.value.ValidFrom && currentTime > campaignForm.value.ValidFrom" style="font-size:13px; color:gray; margin:0; margin-top:10px;">{{ 'T4.CampaignCard.dateUntil' | translate:'Valid until'}} {{campaignForm.value.ValidThrough | date: 'dd-MMM' }}</p>
                <p *ngIf="campaignForm.value.ValidFrom && currentTime < campaignForm.value.ValidFrom" style="font-size:13px; color:gray; margin:0; margin-top:10px;">{{ 'T4.CampaignCard.dateBetween1' | translate:'Valid between'}} {{campaignForm.value.ValidFrom | date: 'dd-MMM'}} {{ 'T4.CampaignCard.dateBetween2' | translate:'and'}} {{campaignForm.value.ValidThrough | date: 'dd-MMM' }}</p>
              }
              <p style="color:black; margin:0.3em; font-size:0.6em; margin-bottom:10px;">
                @if (offerType === 1) {
                {{'T4.CampaignCard.txtDisclaimer' | translate:'The coupon is redeemed in-Station, show the code at the checkout.'}}
                }
                @else if (offerType === 2) {
                @if (campaignForm.value?.PartnerOfferDisclaimer != '') {
                {{ campaignForm.value.PartnerOfferDisclaimer }}
                }
                @else {
                {{ 'T4.CampaignCard.Placeholder.Disclaimer' | translate:'Disclaimer' }}
                }
                }
                @else if(offerType == 3)
                {
                <button style="border-radius:25px; margin-bottom:10px;" type="button" mat-raised-button color="primary" (click)="openInNewTab(campaignForm.value.ExternalCode)"> {{ 'T4.CampaignCard.btnToProducts' | translate:'Show me!'}}</button>
                }

              </p>
            </div>
          </div>
        </ng-container>
      </div>

      <div #scrollableContainer style="overflow-y: scroll; padding: 30px; border: 1px solid #ccc; background: #fff;" class="col-6">
        <!--<div>
          <mat-radio-group aria-label="Type" style="display:flex; justify-content:space-evenly;" formControlName="PartnerOfferType" (change)="offerType = $event.value">
            <mat-radio-button [value]="1">{{'T4.Campaigns.PartnerCampaign.TxtTypeActivationCode' | translate: 'Activation code'}}</mat-radio-button>
            <mat-radio-button [value]="2">{{'T4.Campaigns.PartnerCampaign.TxtTypeInformation' | translate: 'Information'}}</mat-radio-button>
          </mat-radio-group>
        </div>-->

        <div>
          <p>{{'T4.Campaigns.PartnerCampaign.txtSelectOfferType' | translate: 'Select what kind of offer to create.'}}</p>
          <mat-form-field>
            <mat-label>{{'T4.Campaigns.PartnerCampaign.txtLblOfferType' | translate: 'Offer type'}}</mat-label>
            <mat-select formControlName="PartnerOfferType" (selectionChange)="offerType = $event.value">
              <mat-option [value]="1">{{'T4.Campaigns.PartnerCampaign.TxtTypeDiscountCode' | translate: 'Discount code'}}</mat-option>
              <mat-option [value]="2">{{'T4.Campaigns.PartnerCampaign.TxtTypeAdvertisement' | translate: 'Advertisement'}}</mat-option>
              <mat-option [value]="3">{{'T4.Campaigns.PartnerCampaign.TxtTypePopupAdvertisement' | translate: 'Popup Advertisement'}}</mat-option>
            </mat-select>
          </mat-form-field>


          @if (offerType == 1) { <!-- Discount Code -->
          <p class="info-text">
            {{'T4.Campaigns.PartnerCampaign.txtInfoDiscountCode' | translate: 'Creates a discount coupon that customers can activate and scan in-store to receive a price reduction.'}}
          </p>
          }
          @else if (offerType == 2) { <!-- Advertisement -->
          <p class="info-text">
            {{'T4.Campaigns.PartnerCampaign.txtInfoAdvertisement' | translate: 'Displays a promotional advertisement to customers and requires a link to additional information or an external page.'}}
          </p>
          }
          @else if(offerType == 3){ <!-- Popup Adverisement -->
          <p class="info-text">
            {{'T4.Campaigns.PartnerCampaign.txtInfoPopupAdvertisement' | translate: 'Displays a promotional popup advertisement to customers and requires a link to additional information or an external page.'}}
          </p>
          }
        </div>

        <hr />


        @if(offerType == 1){
        <ng-container>
          <div>
            <p><span style="font-weight:bold;">1</span>. {{ 'T4.Campaigns.PartnerCampaign.txtSelectImage' | translate:'Select a image to be used as background for the offer.'}}</p>
            <p style="color:gray; font-style:italic;"> {{ 'T4.Campaigns.PartnerCampaign.txtIfNoImage' | translate:'If no image is provided, a defualt image will be used.'}} </p>
            <p style="color:gray; font-size:10px; margin:0;">{{ 'T4.Campaigns.PartnerCampaign.txtImageFormatRequirement' | translate:'Format on the image : 1:1'}}</p>
            <p style="color:gray; font-size:10px; margin:0">{{ 'T4.Campaigns.PartnerCampaign.txtImageMaxSize' | translate:'Max size 3mb'}}</p>
            <p style="color:gray; font-size:10px; margin:0">{{ 'T4.Campaigns.PartnerCampaign.txtImageFileTypes' | translate:'Allowed file types: .jpg .jpeg .png'}}</p>

            <button mat-stroked-button style="border-radius:15px; margin-top:10px;" type="button" (click)="beginUpload()">{{ 'T4.Campaigns.PartnerCampaign.BtnSelectFile' | translate:'Select file'}}</button>
            <input #txtFile type="file" accept="image/png, image/jpeg, image/jpg" style="visibility:hidden" (change)="upload($event.target.files)" />

          </div>
         
          <div class="steps" style="margin-top:10px;">
            <p><span style="font-weight:bold;">2</span>.{{ 'T4.Campaigns.PartnerCampaign.txtAddTitle' | translate:'Add a headline to the offer.'}} </p>
            <mat-form-field appearance="outline" style="width:100%;">
              <input matInput  #titleInput type="text" formControlName="Title">
              <button mat-icon-button
                      matSuffix
                      type="button"
                      [matMenuTriggerFor]="emojiMenuTitle" style="padding:0px;"
                       #emojiMenuTrigger="matMenuTrigger">
                  😊 
              </button>
            </mat-form-field>

              
            <mat-menu #emojiMenuTitle="matMenu" panelClass="emoji-menu-panel">
              <div class="emoji-menu-wrapper"
                   (click)="$event.stopPropagation()"
                   (mousedown)="$event.stopPropagation()">
                <t4-emoji-picker (emojiSelected)="addEmoji($event, 'Title', titleInput); emojiMenuTrigger.closeMenu()">
                </t4-emoji-picker>
              </div>
            </mat-menu>

            <small *ngIf="campaignForm.get('Title').hasError('required')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleRequired' | translate:'Title is required.'}}</small>
            <small *ngIf="campaignForm.get('Title').hasError('maxlength')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleLenght' | translate:'Title cant be longer the 30 characters.'}}</small>
          </div>
          <div class="steps">

            <p><span style="font-weight:bold;">3</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddDescription' | translate:'Describe the offer for your customer.'}}</p>
            <mat-form-field appearance="outline">
              <textarea matInput #commentInput formControlName="Comment"></textarea>
              <button mat-icon-button
                      matSuffix
                      type="button"
                      [matMenuTriggerFor]="emojiMenuComment"
                      #emojiMenuTriggerComment="matMenuTrigger"
                      style="padding:0px;">
                😊
              </button>
            </mat-form-field>

            <mat-menu #emojiMenuComment="matMenu" panelClass="emoji-menu-panel">
              <div class="emoji-menu-wrapper"
                   (click)="$event.stopPropagation()"
                   (mousedown)="$event.stopPropagation()"
                   (keydown)="$event.stopPropagation()">

                <t4-emoji-picker (emojiSelected)="addEmoji($event, 'Comment', commentInput); emojiMenuTriggerComment.closeMenu()">
                </t4-emoji-picker>

              </div>
            </mat-menu>

            <small *ngIf="campaignForm.get('Comment').hasError('required')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleComment' | translate:'Description is required.'}}</small>
          </div>

          <div class="steps">
            <p><span style="font-weight:bold;">4</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddExternalCode' | translate:'Add Discount code from your system.'}} <mat-icon matTooltip="{{ 'T4.Campaigns.PartnerCampaign.toolTipExternalCode' | translate:'External Code: A discount code from your system that will be linked to this offer.'}}" style="float:right;">help</mat-icon></p>
            <mat-form-field appearance="outline">
              <input matInput formControlName="ExternalCode">
            </mat-form-field>
            <small *ngIf="campaignForm.get('ExternalCode').hasError('required')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleExternalCode1' | translate:'External code is required.'}}</small>
          </div>

          <div class="steps">
            <p><span style="font-weight:bold;">5</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddDateRange' | translate:'When should the offer be active'}}</p>
            <mat-form-field appearance="outline">
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="{{ 'T4.Campaigns.PartnerCampaign.lblStartDate' | translate:'Start date'}}" formControlName="ValidFrom">
                <input matEndDate placeholder="{{ 'T4.Campaigns.PartnerCampaign.lblEndDate' | translate:'End date'}}" formControlName="ValidThrough">
              </mat-date-range-input>
              <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <div style="display: flex; flex-direction: row;">
              <small *ngIf="campaignForm.get('ValidFrom').errors?.required || campaignForm.get('ValidThrough').errors?.required">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgReqDate' | translate:'Start and end date is required.'}}</small>
            </div>
          </div>

          <div class="steps">
            <p><span style="font-weight:bold;">6</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddTrigger' | translate:'Select when the offer should be sent'}} <mat-icon matTooltip="{{ 'T4.Campaigns.PartnerCampaign.toolTipTrigger' | translate:'Triggers: Determines the timing for sending out offer or discounts based on selected conditions.'}}" style="float:right;">help</mat-icon></p>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'T4.Campaigns.PartnerCampaign.selectTriggers' | translate:'Triggers'}}</mat-label>
              <select matNativeControl formControlName="Trigger">
                <option value="1">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalStart' | translate:'When the booking have started'}}</option>
                <option value="2">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalEnd' | translate:'After the booking is returned'}}</option>
                <option value="3">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalCreated' | translate:'When the booking have been created.'}}</option>
                <option value="4">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalCreatedRemotely' | translate:'When the booking have been created remotely.'}}</option>
                <option value="5">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalCreatedOnSite' | translate:'When the booking have been created on site.'}}</option>
              </select>
            </mat-form-field>
          </div>
        </ng-container>
        }

        @else if(offerType == 2){
        <ng-container>
          <div>
            <p><span style="font-weight:bold;">1</span>. {{ 'T4.Campaigns.PartnerCampaign.txtSelectImage' | translate:'Select a image to be used as background for the offer.'}}</p>
            <p style="color:gray; font-style:italic;"> {{ 'T4.Campaigns.PartnerCampaign.txtIfNoImage' | translate:'If no image is provided, a defualt image will be used.'}} </p>
            <p style="color:gray; font-size:10px; margin:0;">{{ 'T4.Campaigns.PartnerCampaign.txtImageFormatRequirement' | translate:'Format on the image : 1:1'}}</p>
            <p style="color:gray; font-size:10px; margin:0">{{ 'T4.Campaigns.PartnerCampaign.txtImageMaxSize' | translate:'Max size 3mb'}}</p>
            <p style="color:gray; font-size:10px; margin:0">{{ 'T4.Campaigns.PartnerCampaign.txtImageFileTypes' | translate:'Allowed file types: .jpg .jpeg .png'}}</p>

            <button mat-stroked-button style="border-radius:15px; margin-top:10px;" type="button" (click)="beginUpload()">{{ 'T4.Campaigns.PartnerCampaign.BtnSelectFile' | translate:'Select file'}}</button>
            <input #txtFile type="file" accept="image/png, image/jpeg, image/jpg" style="visibility:hidden" (change)="upload($event.target.files)" />

          </div>

          <div class="steps" style="margin-top:10px;">
            <p><span style="font-weight:bold;">2</span>.{{ 'T4.Campaigns.PartnerCampaign.txtAddTitle' | translate:'Add a headline to the offer.'}} </p>
            <mat-form-field appearance="outline" style="width:100%;">
              <input matInput #titleInput type="text" formControlName="Title">
              <button mat-icon-button
                      matSuffix
                      type="button"
                      [matMenuTriggerFor]="emojiMenuTitle" style="padding:0px;"
                      #emojiMenuTrigger="matMenuTrigger">
                😊
              </button>
            </mat-form-field>


            <mat-menu #emojiMenuTitle="matMenu" panelClass="emoji-menu-panel">
              <div class="emoji-menu-wrapper"
                   (click)="$event.stopPropagation()"
                   (mousedown)="$event.stopPropagation()">
                <t4-emoji-picker (emojiSelected)="addEmoji($event, 'Title', titleInput); emojiMenuTrigger.closeMenu()">
                </t4-emoji-picker>
              </div>
            </mat-menu>
            <small *ngIf="campaignForm.get('Title').hasError('required')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleRequired' | translate:'Title is required.'}}</small>
            <small *ngIf="campaignForm.get('Title').hasError('maxlength')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleLenght' | translate:'Title cant be longer the 30 characters.'}}</small>
          </div>
          <div class="steps">
            <p><span style="font-weight:bold;">3</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddDescription' | translate:'Describe the offer for your customer.'}}</p>
            <mat-form-field appearance="outline">
              <textarea matInput #commentInput formControlName="Comment"></textarea>
              <button mat-icon-button
                      matSuffix
                      type="button"
                      [matMenuTriggerFor]="emojiMenuComment"
                      #emojiMenuTriggerComment="matMenuTrigger"
                      style="padding:0px;">
                😊
              </button>
            </mat-form-field>

            <mat-menu #emojiMenuComment="matMenu" panelClass="emoji-menu-panel">
              <div class="emoji-menu-wrapper"
                   (click)="$event.stopPropagation()"
                   (mousedown)="$event.stopPropagation()"
                   (keydown)="$event.stopPropagation()">

                <t4-emoji-picker (emojiSelected)="addEmoji($event, 'Comment', commentInput); emojiMenuTriggerComment.closeMenu()">
                </t4-emoji-picker>

              </div>
            </mat-menu>
            <small *ngIf="campaignForm.get('Comment').hasError('required')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleComment' | translate:'Description is required.'}}</small>
          </div>

          <div class="steps">
            <p><span style="font-weight:bold;">4</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddButtonAction' | translate:'Add a website or Url where we redirect the customer.'}} <mat-icon matTooltip="{{ 'T4.Campaigns.PartnerCampaign.toolTipButtonAction' | translate:'As example, a webpage to either download an application, or where they can read more about the offers.'}}" style="float:right;">help</mat-icon></p>
            <mat-form-field appearance="outline">
              <input matInput formControlName="ExternalCode">
            </mat-form-field>
            <small *ngIf="campaignForm.get('ExternalCode').hasError('required')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleExternalCode2' | translate:'An url or wbsite is required.'}}</small>
          </div>
          <div class="steps">
            <p><span style="font-weight:bold;">5</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddDisclaimer' | translate:'Add a Disclaimer, regarding how to use it, where to find it.'}}</p>
            <mat-form-field appearance="outline">
              <textarea matInput formControlName="PartnerOfferDisclaimer"></textarea>
            </mat-form-field>
          </div>

          <div class="steps">
            <p><span style="font-weight:bold;">6</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddDateRange' | translate:'When should the offer be active'}}</p>
            <mat-form-field appearance="outline">
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="{{ 'T4.Campaigns.PartnerCampaign.lblStartDate' | translate:'Start date'}}" formControlName="ValidFrom">
                <input matEndDate placeholder="{{ 'T4.Campaigns.PartnerCampaign.lblEndDate' | translate:'End date'}}" formControlName="ValidThrough">
              </mat-date-range-input>
              <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <div style="display: flex; flex-direction: row;">
              <small *ngIf="campaignForm.get('ValidFrom').errors?.required || campaignForm.get('ValidThrough').errors?.required">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgReqDate' | translate:'Start and end date is required.'}}</small>
            </div>
          </div>

          <div class="steps">
            <p><span style="font-weight:bold;">7</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddTrigger' | translate:'Select when the offer should be sent'}} <mat-icon matTooltip="{{ 'T4.Campaigns.PartnerCampaign.toolTipTrigger' | translate:'Triggers: Determines the timing for sending out offer or discounts based on selected conditions.'}}" style="float:right;">help</mat-icon></p>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'T4.Campaigns.PartnerCampaign.selectTriggers' | translate:'Triggers'}}</mat-label>
              <select matNativeControl formControlName="Trigger">
                <option value="1">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalStart' | translate:'When the booking have started'}}</option>
                <option value="2">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalEnd' | translate:'After the booking is returned'}}</option>
                <option value="3">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalCreated' | translate:'When the booking have been created.'}}</option>
                <option value="4">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalCreatedRemotely' | translate:'When the booking have been created remotely.'}}</option>
                <option value="5">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalCreatedOnSite' | translate:'When the booking have been created on site.'}}</option>
              </select>
            </mat-form-field>
          </div>
        </ng-container>
        }

        @else if(offerType == 3){
        <div class="steps" style="margin-top:10px;">
          <p><span style="font-weight:bold;">1</span>.{{ 'T4.Campaigns.PartnerCampaign.txtAddTitle' | translate:'Add a headline to the offer.'}} </p>
          <mat-form-field appearance="outline" style="width:100%;">
            <input matInput type="text" formControlName="Title">
          </mat-form-field>
          <small *ngIf="campaignForm.get('Title').hasError('required')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleRequired' | translate:'Title is required.'}}</small>
          <small *ngIf="campaignForm.get('Title').hasError('maxlength')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleLenght' | translate:'Title cant be longer the 30 characters.'}}</small>
        </div>

        <div class="steps">
          <p><span style="font-weight:bold;">2</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddDescription' | translate:'Describe the offer for your customer.'}}</p>
          <mat-form-field appearance="outline">
            <textarea matInput formControlName="Comment"></textarea>
          </mat-form-field>
          <small *ngIf="campaignForm.get('Comment').hasError('required')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleComment' | translate:'Description is required.'}}</small>
        </div>

        <div class="steps">
          <p><span style="font-weight:bold;">3</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddButtonAction' | translate:'Add a website or Url where we redirect the customer.'}} <mat-icon matTooltip="{{ 'T4.Campaigns.PartnerCampaign.toolTipButtonAction' | translate:'As example, a webpage to either download an application, or where they can read more about the offers.'}}" style="float:right;">help</mat-icon></p>
          <mat-form-field appearance="outline">
            <input matInput formControlName="ExternalCode">
          </mat-form-field>
          <small *ngIf="campaignForm.get('ExternalCode').hasError('required')">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgTitleExternalCode2' | translate:'An url or wbsite is required.'}}</small>
        </div>

        <div class="steps">
          <p><span style="font-weight:bold;">4</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddDateRange' | translate:'When should the offer be active'}}</p>
          <mat-form-field appearance="outline">
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="{{ 'T4.Campaigns.PartnerCampaign.lblStartDate' | translate:'Start date'}}" formControlName="ValidFrom">
              <input matEndDate placeholder="{{ 'T4.Campaigns.PartnerCampaign.lblEndDate' | translate:'End date'}}" formControlName="ValidThrough">
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
          <div style="display: flex; flex-direction: row;">
            <small *ngIf="campaignForm.get('ValidFrom').errors?.required || campaignForm.get('ValidThrough').errors?.required">{{ 'T4.Campaigns.PartnerCampaign.ErrorMsgReqDate' | translate:'Start and end date is required.'}}</small>
          </div>
        </div>

        <div class="steps">
          <p><span style="font-weight:bold;">5</span>. {{ 'T4.Campaigns.PartnerCampaign.txtAddTrigger' | translate:'Select when the offer should be sent'}} <mat-icon matTooltip="{{ 'T4.Campaigns.PartnerCampaign.toolTipTrigger' | translate:'Triggers: Determines the timing for sending out offer or discounts based on selected conditions.'}}" style="float:right;">help</mat-icon></p>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'T4.Campaigns.PartnerCampaign.selectTriggers' | translate:'Triggers'}}</mat-label>
            <select matNativeControl formControlName="Trigger">
              <option value="3">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalCreated' | translate:'When the booking have been created.'}}</option>
              <option value="4">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalCreatedRemotely' | translate:'When the booking have been created remotely.'}}</option>
              <option value="5">{{ 'T4.Campaigns.PartnerCampaign.Trigger.onRentalCreatedOnSite' | translate:'When the booking have been created on site.'}}</option>
            </select>
          </mat-form-field>
        </div>
        }
      </div>
    </div>

  </form>

</mat-dialog-content>

<mat-dialog-actions style="justify-content:end;" *ngIf="canEdit">
  <button mat-raised-button>{{ 'T4.Campaigns.PartnerCampaign.btnCancel' | translate:'Cancel'}}</button>
  <button mat-raised-button color="primary" [disabled]="campaignForm.invalid" (click)="save()">{{ 'T4.Campaigns.PartnerCampaign.btnSave' | translate:'Save'}}</button>
</mat-dialog-actions>
